import { render, staticRenderFns } from "./SideWindow.vue?vue&type=template&id=7f1ac46a&scoped=true&"
import script from "./SideWindow.vue?vue&type=script&lang=js&"
export * from "./SideWindow.vue?vue&type=script&lang=js&"
import style0 from "./SideWindow.vue?vue&type=style&index=0&id=7f1ac46a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1ac46a",
  null
  
)

export default component.exports